import { useState, useCallback, useEffect } from "react";

interface IUseMouseDownAnimation {
    /** Состояние clicked у компонента */
    clicked: boolean;
    /** обработчиком события mousedown */
    mousedownHandler: () => void;
}

/**
 * useMouseDownAnimation - хук для анимации нажатия на компонент.
 *
 * @param {number} duration - Продолжительность анимации в миллисекундах (по умолчанию 300 мс).
 * @returns {IUseMouseDownAnimation} - Объект с состоянием clicked и обработчиком события mousedownHandler.
 */
export const useMouseDownAnimation = (
    duration = 300,
): IUseMouseDownAnimation => {
    const [clicked, setClicked] = useState(false);

    const mousedownHandler = useCallback(() => {
        setClicked(true);
    }, []);

    useEffect(() => {
        if (clicked) {
            const timer = setTimeout(() => {
                setClicked(false);
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [clicked, duration]);

    return { clicked, mousedownHandler };
};
